export default {
  BACKFILL_MODAL: {
    title: (pendingTeacherRequestCount: number, pendingClassRequestCount: number) =>
      `This will affect existing
      ${pendingTeacherRequestCount ? 'teachers' : ''}
      ${pendingTeacherRequestCount && pendingClassRequestCount ? 'and' : ''}
      ${pendingClassRequestCount ? 'classes' : ''}`,
    subtext: {
      teachers: (pendingTeacherRequestCount: number) =>
        pendingTeacherRequestCount > 0
          ? `${pendingTeacherRequestCount} unverified teacher${
              pendingTeacherRequestCount > 1 ? 's' : ''
            }
            will be asked to request administrator approval or change their role to student or parent.`
          : '',
      classes: (pendingClassRequestCount: number) =>
        pendingClassRequestCount > 0
          ? `${pendingClassRequestCount} class${pendingClassRequestCount > 1 ? 'es' : ''} 
            owned by students, parents and unverified teachers will be pending and class owners will be asked to request administrator approval or archive the class.`
          : '',
    },
    buttons: {
      submit: {
        copy: 'Apply changes',
      },
      learnMore: {
        copy: 'Learn more',
        href: 'https://remind101.zendesk.com/knowledge/articles/360012343319/en-us?brand_id=108636',
      },
    },
  },

  CLASS_CREATION_TO_HELPTEXT: {
    open: 'Anyone can create classes at this school.',
    requireApproval:
      'Classes created by students and parents need to be approved by an administrator. Teacher- or SIS-created classes are approved automatically.',
  },

  CLASS_CREATION_TO_LABEL: {
    open: 'Open',
    requireApproval: 'Require approval',
  },

  CLASS_CREATION_TOOLTIP: 'To enable this option, require approval for teacher signup.',

  CONFIRM_DIALOG: {
    title: 'You haven’t saved your changes',
    body:
      'Click save at the bottom of the screen and decide if you want to apply the changes to existing classes at your school.',
    buttons: {
      action: 'Go back',
      cancel: 'Discard changes',
    },
  },

  APPROVAL_HEADER_TITLE: 'Teacher and Class approval settings',

  APPROVAL_HEADER_SUBTEXT: {
    text:
      'Choose the default settings for how teachers and classes are added to schools. These settings can be changed individually at the school-level.',
    learnMoreLink: {
      copy: 'Learn More',
      href: 'https://remind101.zendesk.com/knowledge/articles/360012343319/en-us?brand_id=108636',
    },
  },

  CLASSCODE_HEADER_TITLE: {
    School: 'School code',
    District: 'District code',
  },

  CLASSCODE_HEADER_SUBTEXT: {
    School:
      'This code allows people to join the school directly and receive schoolwide announcements.',
    District:
      'This code is for internal district use only. Use it when submitting a list of people who need district administrator access. Please contact support via rmd.me/help with questions.',
  },

  HEADER_TITLE: 'Organization settings',

  HEADING_FOR_SETTING_TYPE: {
    teacherSignup: 'Teacher signup',
    classCreation: 'Student and parent class creation',
  },

  PENDING_REQUESTS_MODAL: {
    title: 'Approve pending requests?',
    subtext: (pendingTeacherRequestCount: number, pendingClassRequestCount: number) =>
      `If you set teacher signup and class creation to open,
      ${
        pendingTeacherRequestCount
          ? `${pendingTeacherRequestCount} pending teacher request${
              pendingTeacherRequestCount > 1 ? 's' : ''
            }`
          : ''
      }
      ${pendingTeacherRequestCount && pendingClassRequestCount ? 'and' : ''}
      ${
        pendingClassRequestCount
          ? `${pendingClassRequestCount} pending class request${
              pendingClassRequestCount > 1 ? 's' : ''
            }`
          : ''
      }
      will be approved.`,
    buttons: {
      submit: {
        copy: 'Approve requests',
      },
      cancel: {
        copy: 'Cancel',
      },
    },
  },

  TEACHER_SIGNUP_TO_LABEL: {
    open: 'Open',
    requireApproval: 'Require approval',
  },

  TEACHER_SIGNUP_TO_HELPTEXT: {
    open: 'Anyone can join the school as a teacher.',
    requireApproval:
      'People who join the school as a teacher need to be approved by an administrator. SIS-synced teachers are approved automatically.',
  },
};
